import PropTypes from "prop-types";
import React from "react";
import {
  CalendarSettings,
  ExportCalendar,
  ImportCalendar,
  CreateEvent,
  CreateCalendar
} from "../../components/Calendar/Modals";
import { defaultEventDurations } from "../../constants";

const CalendarModals = ({
  onImportModalOpenChange,
  importModalOpen,
  onExportModalOpenChange,
  exportModalOpen,
  onSettingsModalOpenChange,
  settingsModalOpen,
  onCreateEventModalOpenChange,
  onEditEventModalOpenChange,
  createEventModalOpen,
  editEventModalOpen,
  createEventModalErrors,
  event,
  user,
  onCreateCalendarModalOpenChange,
  createCalendarModalOpen,
  onCreateNewEvent,
  onUpdateEvent,
  onDeleteEvent,
  onImportNewCalendar,
  trainingCalendars,
  allCalendars,
  otherCalendars,
  onCreateNewCalendar,
  onUpdateCalendarSettings,
  calendarFeedLink
}) => (
  <>
    <ImportCalendar
      onOpenChange={onImportModalOpenChange}
      open={importModalOpen}
      onSubmit={onImportNewCalendar}
    />
    <ExportCalendar
      onOpenChange={onExportModalOpenChange}
      open={exportModalOpen}
      trainingCalendarList={trainingCalendars}
      calendarFeedLink={calendarFeedLink}
    />
    <CalendarSettings
      onOpenChange={onSettingsModalOpenChange}
      open={settingsModalOpen}
      onSubmit={onUpdateCalendarSettings}
    />
    {createEventModalOpen && (
      <CreateEvent
        user={user}
        calendars={otherCalendars.calendars}
        open={createEventModalOpen}
        onOpenChange={onCreateEventModalOpenChange}
        onSubmit={onCreateNewEvent}
        errors={createEventModalErrors}
        defaultEventDuration={defaultEventDurations.oneHour}
      />
    )}
    {editEventModalOpen && (
      <CreateEvent
        event={event}
        user={user}
        calendars={otherCalendars.calendars}
        open={editEventModalOpen}
        onOpenChange={onEditEventModalOpenChange}
        onSubmit={onUpdateEvent}
        onDelete={onDeleteEvent}
        errors={createEventModalErrors}
      />
    )}
    <CreateCalendar
      open={createCalendarModalOpen}
      onOpenChange={onCreateCalendarModalOpenChange}
      onSubmit={onCreateNewCalendar}
    />
  </>
);

CalendarModals.propTypes = {
  /**
   * True if the create event modal is open, false otherwise
   */
  createEventModalOpen: PropTypes.bool,
  /**
   * True if the edit event modal is open, false otherwise
   */
  editEventModalOpen: PropTypes.bool,
  /**
   * True if the export calendar modal is open, false otherwise
   */
  exportModalOpen: PropTypes.bool,
  /**
   * True if the import calendar modal is open, false otherwise
   */
  importModalOpen: PropTypes.bool,
  /**
   * Called when the create event modal is open or closed
   */
  onCreateEventModalOpenChange: PropTypes.func,
  /**
   * Called when the edit event modal is open or closed
   */
  onEditEventModalOpenChange: PropTypes.func,
  /**
   * Called when the user creates a new event from the create event modal
   */
  onCreateNewEvent: PropTypes.func,
  /**
   * Called when the user updates an event from the edit event modal
   */
  onUpdateEvent: PropTypes.func,
  /**
   * Called when the user deletes an event from the create event modal
   */
  onDeleteEvent: PropTypes.func,
  /**
   * Called when the export calendar modal is open or closed
   */
  onExportModalOpenChange: PropTypes.func,
  /**
   * Called when the import calendar modal is open or closed
   */
  onImportModalOpenChange: PropTypes.func,
  /**
   * Called when the user imports a new calendar from the import calendar modal
   */
  onImportNewCalendar: PropTypes.func,
  /**
   * Called when the calendar settings modal is open or closed
   */
  onSettingsModalOpenChange: PropTypes.func,
  /**
   * True if the calendar settings modal is open, false otherwise
   */
  settingsModalOpen: PropTypes.bool,
  /**
   * Called when the user saves their calendar settings from the calendar settings modal
   */
  onUpdateCalendarSettings: PropTypes.func,
  /**
   * Called when the user creates a new calendar from the create new calendar modal
   */
  onCreateNewCalendar: PropTypes.func
};

export default CalendarModals;
